import router from '@/router'
import { useVirementStore } from './useVirementStore'
import { navigateTo } from '@/router/navigateTo'

export function useVirementRoutingService() {
  const store = useVirementStore()

  async function loadStoreWithKey(key: any): Promise<boolean> {
    try {
      await store.loadData(key)
      return true
    } catch {
      return false
    }
  }

  function navigateToWithKey(key: any) {
    // const appState = useAppStateStore()
    // const context = TypesContextesAutorisesEnum[appState.contextCourant]
    // router.push(`/${context}/virement/${key}`)
    navigateTo({
      to: 'detail',
      domaine: 'virements',
      code: key
    })
  }

  function navigateToFactureWithKey(key: any) {
    // const appState = useAppStateStore()
    // const context = TypesContextesAutorisesEnum[appState.contextCourant]
    // router.push(`/${context}/facture/${key}`)
    navigateTo({
      to: 'detail',
      domaine: 'factures',
      code: key
    })
  }

  function navigateToRechercheVirementsList() {
    const backPath = window.history.state.back as string | undefined
    const isBackToRecherche = backPath && /\/virements(\?|$)/.test(backPath)

    if (isBackToRecherche) {
      router.go(-1)
    } else {
      navigateTo({
        to: 'recherche',
        domaine: 'virements'
      })
    }
  }

  return { loadStoreWithKey, navigateToWithKey, navigateToFactureWithKey, navigateToRechercheVirementsList }
}

